import axios from 'axios'
import environment from '@/environment'

const apiProvider = axios.create({
    validateStatus(status) {
        return status >= 200 && status <= 522
    },
    baseURL: environment.authApi,
    headers: {
        'Content-type': 'application/json',
    },
})

export default {
    apiProvider,
}
